import { CONSTANTS } from './constants';

export default {
  onLogin: function () {
    const loginHtmlCollection = document.getElementsByTagName(CONSTANTS.COMPONENTS.MODAL_LOGIN)
    const modalLoginCollection = [...loginHtmlCollection]
    modalLoginCollection.forEach(loginModal => { loginModal.show = false })

    this.onAuthStatusChange()
  },

  onLogout: function (event) {
    if (event) {
      event.preventDefault()
    }

    window.AngularEcommerce.web.stores.dispatch('auth/logout')
      .then(() => {
        // direciona pra home após fazer logout
        if (location.hostname !== 'editor.angulare.app') {
          location.href = '/';
          return;
        }

        const base = location.href.split('/')
        const siteNameIndex = base.findIndex(item => item === 'site') + 2
        const siteName = base.slice(0, siteNameIndex).join('/')

        location.href = `${siteName}?${location.search}`
      });
  },

  onAuthStatusChange: function () {
    const isLogged = window.AngularEcommerce.web.stores.getters['auth/isLogged']
    const user = window.AngularEcommerce.web.stores.getters['auth/user']

    const containerLogged = document.querySelectorAll(`[${CONSTANTS.CONTAINERS.LOGGED}]`)
    const containerUnlogged = document.querySelectorAll(`[${CONSTANTS.CONTAINERS.UNLOGGED}]`)
    const containerUsername = document.querySelectorAll(`[${CONSTANTS.CONTAINERS.USERNAME}]`)

    if (isLogged) {
      containerLogged.forEach(container => container.setAttribute('style', 'display: block !important;'))
      containerUnlogged.forEach(container => container.setAttribute('style', 'display: none !important;'))
      containerUsername.forEach(container => container.textContent = user.first_name)
    } else {
      containerUnlogged.forEach(container => container.setAttribute('style', 'display: block !important;'))
      containerLogged.forEach(container => container.setAttribute('style', 'display: none !important;'))
      containerUsername.forEach(container => container.textContent = 'Usuário')
    }
  }
}
